export const siteInfo = {
  name: "料闻社",
  slogan: "独家黑料速递 · 今日新料实时更新",
  description:
    "料闻社是一个专注娱乐行业动态的速递型资讯站，把散落的传闻、回应与时间点整理成可读的条目与完整时间线，让读者一次看完事件来龙去脉。",
  email: "tips@liaowenshe.example.com",
  replyTime: "工作日 10:00 - 19:00 集中回复",
  updateNote: "每日 08:00 / 14:00 / 22:00 三档更新",
};

export const siteStats = [
  { label: "今日新增条目", value: "128", unit: "条" },
  { label: "累计时间线", value: "3.4", unit: "万条" },
  { label: "速递订阅读者", value: "26.8", unit: "万" },
  { label: "平均追踪时长", value: "4.2", unit: "天/事件" },
];

export const categories = [
  {
    slug: "figures",
    name: "人物动态",
    icon: "ri-user-star-line",
    intro: "记录当事人近期的公开行程、合作变化与团队动作，只整理可对照的公开信息。",
  },
  {
    slug: "events",
    name: "事件追踪",
    icon: "ri-radar-line",
    intro: "对正在发酵的事件保持连续性跟进，标注每一条信息的出现时间与可信程度。",
  },
  {
    slug: "timeline",
    name: "时间线梳理",
    icon: "ri-timeline-view",
    intro: "把同一事件里前后矛盾的说法按时间重排，还原一条能读懂的来龙去脉。",
  },
  {
    slug: "briefs",
    name: "快报专栏",
    icon: "ri-flashlight-line",
    intro: "短、快、密。每天把最新条目压缩成一份清单，适合碎片时间快速浏览。",
  },
  {
    slug: "industry",
    name: "行业观察",
    icon: "ri-bar-chart-grouped-line",
    intro: "从数据与产业结构出发，解释某类传闻为什么会在这段时间集中出现。",
  },
];

export const trendingList = [
  { rank: 1, title: "林知遥新专辑进入收尾，录音棚路透被反复核对", tag: "人物动态", articleId: "lin-zhihao-album" },
  { rank: 2, title: "顾沉合约风波时间线：三份声明之间的空白期", tag: "时间线梳理", articleId: "gu-chen-contract-timeline" },
  { rank: 3, title: "沈聿川与苏晚棠同框庆功宴，合作传言口径不一", tag: "人物动态", articleId: "shen-su-banquet" },
  { rank: 4, title: "顶流工作室注销传闻反转：实为业务重组", tag: "事件追踪", articleId: "studio-deregister" },
  { rank: 5, title: "白露旧照翻红：十年前街拍为何突然刷屏", tag: "事件追踪", articleId: "bai-lu-old-photo" },
  { rank: 6, title: "江砚直播口误事件完整时间线梳理", tag: "时间线梳理", articleId: "jiang-yan-live-timeline" },
  { rank: 7, title: "本周五条未证实传言清单，请谨慎看待", tag: "快报专栏", articleId: "weekly-unverified-list" },
];

export const articles = [
  {
    id: "lin-zhihao-album",
    slug: "lin-zhihao-album",
    title: "林知遥深夜现身录音棚，新专辑疑进入收尾阶段",
    categorySlug: "figures",
    categoryName: "人物动态",
    author: "料闻社编辑部",
    date: "2026-09-10",
    readTime: 5,
    views: 48213,
    hot: true,
    tags: ["林知遥", "新专辑", "录音棚路透"],
    excerpt:
      "连续三个工作日的夜间时段，林知遥都被看到进出同一间录音棚。团队尚未回应，但从合作名单的变化看，这张专辑的进度或许比外界预计得更快。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20entertainment%20magazine%20cover%20art%2C%20warm%20vermillion%20red%20and%20amber%20gold%20geometric%20shapes%20on%20deep%20charcoal%20background%2C%20film%20grain%20texture%2C%20modern%20minimal%20graphic%20design%2C%20moody%20cinematic%20lighting%2C%20high%20detail&width=800&height=500&seq=liao-cover-lin&orientation=landscape",
    content: [
      "从上周四开始，林知遥的行程出现了明显规律：白天几乎不出现在公开场合，夜里十点之后才被看到进入城东一间长期对外出租的录音棚。据在场的工作人员描述，随行的除了常规的制作助理，还有一位过去三个月频繁出现的编曲老师。",
      "值得留意的是，这位编曲老师此前主要做影视配乐，与林知遥过往的流行曲风并不完全相同。行业里通常把这类组合视为「转型信号」，但更大的可能只是新专辑里的一到两首尝试性作品。在没有官方物料之前，任何结论都为时过早。",
      "把时间往回拉，三个月前林知遥的经纪团队曾一口气注销了两个与巡演相关的工作室主体，当时被解读为「活动收缩」。如今看来，更合理的解释是把资源集中到作品本身：巡演团队解散，制作团队补位。",
      "还有一个容易被忽略的细节：近两周她的社交账号更新频率明显下降，但评论区的互动反而更活跃。这种「少发布、多回复」的节奏，通常出现在艺人进入封闭创作期的阶段。",
      "截至目前，团队对专辑进度仍然保持沉默。按照同类项目的常规周期，从收尾到正式发布通常还需要两到三个月。我们会继续跟进这条线索，一旦出现制作名单或发行窗口的变化，会在快报专栏第一时间更新。",
    ],
  },
  {
    id: "shen-su-banquet",
    slug: "shen-su-banquet",
    title: "沈聿川与苏晚棠同框庆功宴，合作新剧传言再起",
    categorySlug: "figures",
    categoryName: "人物动态",
    author: "料闻社编辑部",
    date: "2026-09-10",
    readTime: 4,
    views: 39870,
    hot: true,
    tags: ["沈聿川", "苏晚棠", "庆功宴"],
    excerpt:
      "一张庆功宴合影让两个人的名字一起挂上了热搜。真正有意思的不是同框本身，而是双方团队对「是否二搭」给出了完全不同的口径。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20art%20with%20overlapping%20warm%20crimson%20and%20soft%20cream%20paper%20circles%20on%20dark%20ink%20background%2C%20textured%20risograph%20print%20style%2C%20elegant%20magazine%20layout%20aesthetic%2C%20soft%20directional%20light%2C%20subtle%20grain%2C%20high%20detail&width=800&height=500&seq=liao-cover-shen&orientation=landscape",
    content: [
      "庆功宴的照片在凌晨被放出来时并没有引起太多注意，真正的转折发生在上午——有账号把照片里两人站位的距离做了标注对比，于是「二搭」的说法重新被推上台面。",
      "需要说明的是，这种同框本身没有太大信息量。行业里的庆功宴通常按项目分组站位，关系远近和站得近不近之间没有必然联系。把它当作「关系证据」并不成立。",
      "更值得关注的是两个团队的态度差异。沈聿川方面在回应里用了「目前没有接触」的措辞，而苏晚棠方面则说「项目在讨论阶段，不便多说」。前者是明确否认，后者留了口子，这种不对称在项目早期很常见——通常意味着一方还在报价，另一方还没点头。",
      "从资源角度看，两人上一部合作的播放数据属于中上水准，对平台来说重启这个组合的风险很低。真正卡住二搭的往往是档期：沈聿川明年的排期据传已经被一部电影占掉大半。",
      "结论放在这里：同框是真的，二搭目前仍停留在讨论阶段。我们会在事件追踪里继续跟进这条线，等出现剧本围读或试装的动向，基本就能确认项目是否落地。",
    ],
  },
  {
    id: "studio-deregister",
    slug: "studio-deregister",
    title: "某顶流工作室注销传闻反转：实为业务重组",
    categorySlug: "events",
    categoryName: "事件追踪",
    author: "料闻社编辑部",
    date: "2026-09-09",
    readTime: 4,
    views: 33120,
    hot: false,
    tags: ["工作室", "工商信息", "传闻反转"],
    excerpt:
      "从「解散」到「重组」，同一条工商信息在半天之内被解读出两个完全相反的版本。我们对照了变更记录，发现反转的关键其实藏在一个很小的字段里。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20architectural%20glass%20facade%20reflection%20in%20warm%20amber%20and%20deep%20maroon%20tones%2C%20minimal%20editorial%20photography%2C%20geometric%20repetition%2C%20soft%20evening%20light%2C%20fine%20grain%20texture%2C%20premium%20business%20magazine%20aesthetic%2C%20high%20detail&width=800&height=500&seq=liao-cover-studio&orientation=landscape",
    content: [
      "上午九点，「工作室注销」的说法开始在小圈子里流传；到中午，另一批账号拿出了变更记录截图，指出被注销的主体并非主运营公司，而是同名的品牌管理子公司。",
      "我们对两边的说法都做了核对。关键差异在于「注销」和「业务重组」指向的是不同的工商动作：前者的主体随之终止，后者通常保留主体、只调整经营范围与股权结构。这次的记录更接近后者。",
      "具体来看，调整集中在两个方向：一是把原本分散在三个主体里的商务授权收拢到一个主体，二是把版权的持有关系从个人名下转到公司名下。这两步在业内被视为「准备做长期授权生意」的前置动作。",
      "所以「顶流要退圈」的结论下得太早了。更合理的解读是团队在做资产结构的整理，为接下来的品牌合作和版权运营腾出空间。",
      "这类工商信息容易被过度解读，我们建议读者遇到类似传闻时，先确认三个要素：变更主体是否为核心运营公司、变更类型是注销还是调整、以及是否有后续的备案动作。三者缺一，结论都要打个问号。",
    ],
  },
  {
    id: "bai-lu-old-photo",
    slug: "bai-lu-old-photo",
    title: "白露旧照翻红：十年前街拍为何突然刷屏",
    categorySlug: "events",
    categoryName: "事件追踪",
    author: "料闻社编辑部",
    date: "2026-09-09",
    readTime: 3,
    views: 27640,
    hot: false,
    tags: ["白露", "旧照", "舆情观察"],
    excerpt:
      "一张十年前的街拍在两天内被转发了六万多次。看起来是偶然的怀旧，但传播路径里有一段明显的加速区间，值得单独拎出来看。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20sepia%20toned%20city%20street%20long%20exposure%20with%20warm%20amber%20light%20trails%20and%20deep%20brown%20shadows%2C%20moody%20editorial%20photography%2C%20grainy%20analog%20film%20texture%2C%20nostalgic%20minimal%20composition%2C%20high%20detail&width=800&height=500&seq=liao-cover-bailu&orientation=landscape",
    content: [
      "旧照翻红在内容平台上是周期性的现象，但这次的扩散曲线有点不一样：前六个小时几乎是自然扩散，第七个小时开始出现明显的加速，随后维持了将近一天的高位。",
      "加速区间通常意味着有中间层账号介入。我们观察到，参与转发的账号大多集中在生活方式与穿搭两个垂类，而不是娱乐类账号。这解释了为什么话题的落点是「当年的审美」，而不是「白露本人」。",
      "另一个细节是评论区的关键词分布。「减法」「真实」「没修过」这类词的出现频率远高于颜值相关的词，说明这波怀旧情绪指向的是当下的审美疲劳，而不是对某个人的评价。",
      "对当事人来说，这种性质的热度风险很低。它不涉及作品、不涉及争议，更多是一段公共记忆被重新调用。团队如果选择不介入，反而是合适的处理方式。",
      "我们会把这条线索归入「舆情观察」序列继续观察，如果出现商业层面的后续动作，会单独跟进。",
    ],
  },
  {
    id: "gu-chen-contract-timeline",
    slug: "gu-chen-contract-timeline",
    title: "顾沉合约风波时间线：三份声明之间的空白期",
    categorySlug: "timeline",
    categoryName: "时间线梳理",
    author: "料闻社时间线组",
    date: "2026-09-10",
    readTime: 7,
    views: 51290,
    hot: true,
    tags: ["顾沉", "合约", "时间线", "声明对比"],
    excerpt:
      "从解约传闻到双方声明，中间隔了十一天。这十一天里到底发生了什么，是整件事里信息密度最高、也最容易被忽略的部分。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20timeline%20concept%20art%20with%20floating%20warm%20amber%20nodes%20connected%20by%20thin%20lines%20over%20a%20deep%20charcoal%20gradient%20background%2C%20minimal%20data%20visualization%20aesthetic%2C%20soft%20glow%2C%20film%20grain%2C%20editorial%20design%2C%20high%20detail&width=800&height=500&seq=liao-cover-guchen&orientation=landscape",
    content: [
      "第一份信息出现在 8 月 30 日的深夜，源头是一个注册不满一个月的账号，内容是「合约到期不续」。这条信息没有任何配图，措辞也不像官方口径，当时并没有被广泛采信。",
      "9 月 2 日出现了第一个可核对的信号：顾沉名下两个工作室主体之一的商务授权被暂停，原定在 9 月中旬上线的一支品牌短片从官方排期中消失。这是整件事从「传闻」变成「可观察变化」的节点。",
      "9 月 5 日是空白期里信息量最大的一天。当天有三家品牌方在同一时段调整了相关内容，动作高度同步，这种同步通常意味着他们收到了同一份来自团队的通知。",
      "9 月 7 日，经纪公司发布第一份声明，核心表述是「合作正常推进」。9 月 9 日，顾沉本人账号发出第二份声明，用词是「感谢，未来各自努力」。两份声明之间隔了两天，且措辞指向并不完全一致。",
      "9 月 10 日，品牌方中的两家同步撤下了合作物料，第三家保留。到这里，事件的基本轮廓已经清晰：合约确实走到了需要重新定义关系的阶段，但「解约」这个词未必准确。",
      "把三份关键信息排在一起看，最值得记录的不是结论，而是 9 月 2 日到 9 月 5 日这段「只出现动作、不出现文字」的时期。行业里大多数真实的变化都发生在这一段，而它恰恰是最少被报道的。",
    ],
  },
  {
    id: "jiang-yan-live-timeline",
    slug: "jiang-yan-live-timeline",
    title: "江砚直播口误事件完整时间线梳理",
    categorySlug: "timeline",
    categoryName: "时间线梳理",
    author: "料闻社时间线组",
    date: "2026-09-08",
    readTime: 6,
    views: 35470,
    hot: false,
    tags: ["江砚", "直播", "时间线", "回应"],
    excerpt:
      "一场两小时的直播，因为一句话被截成了十五秒的短视频。我们把原始直播的完整时间轴拉了出来，和流传版本做了逐句对照。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20glowing%20microphone%20silhouette%20in%20warm%20red%20stage%20haze%20against%20dark%20background%2C%20minimal%20editorial%20concert%20poster%20aesthetic%2C%20soft%20volumetric%20light%2C%20film%20grain%2C%20cinematic%20contrast%2C%20high%20detail&width=800&height=500&seq=liao-cover-jiang&orientation=landscape",
    content: [
      "直播发生在 9 月 5 日晚间，全长约 118 分钟。被截取的那句话出现在第 71 分钟，前后各有一个完整的问答回合，但在流传的十五秒版本里，这两个回合都被剪掉了。",
      "我们把原始时间轴做了逐句标注。第 69 分钟到第 70 分钟，江砚在回应弹幕提问时提到了一个不在场的人名；第 71 分钟，他用了一句带有比较意味的表述。单独看这句确实不严谨，但把它放回上下文，语气更接近随口举例，而不是刻意评价。",
      "第 74 分钟，他做了第一时间的自我修正，原话是「刚那句我说得不合适，收回」。这一段在流传版本里同样被剪掉。",
      "9 月 6 日凌晨，短视频开始大规模扩散，多数版本都停留在第 71 分钟、并去掉了修正部分。到当天中午，话题的讨论重心已经从「他说了什么」转向「他为什么这么说」。",
      "9 月 6 日晚间，江砚发布文字回应，承认表达不严谨，未提及被剪辑的问题。这个选择在危机处理上通常被视为「不纠缠细节」，可以理解，但也让一部分观众觉得缺少对剪辑版本的说明。",
      "9 月 7 日之后，话题热度快速回落。整件事的传播高峰只有大约三十小时，属于典型的短周期舆情。真正值得留存的信息是：原始素材完整、修正动作及时，但剪辑传播造成的理解偏差并未被有效纠正。",
    ],
  },
  {
    id: "weekly-unverified-list",
    slug: "weekly-unverified-list",
    title: "速递快报：本周五条未证实传言清单，请谨慎看待",
    categorySlug: "briefs",
    categoryName: "快报专栏",
    author: "料闻社快报组",
    date: "2026-09-10",
    readTime: 3,
    views: 29880,
    hot: true,
    tags: ["快报", "未证实", "传言清单"],
    excerpt:
      "不是所有传闻都值得当真。这一期我们把本周流传最广、但至今缺乏可核对依据的五条整理出来，并标注它们各自卡在了哪里。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20stack%20of%20warm%20cream%20paper%20cards%20with%20red%20thread%20bindings%20on%20dark%20walnut%20desk%2C%20overhead%20editorial%20flat%20lay%2C%20soft%20window%20light%2C%20minimal%20stationery%20aesthetic%2C%20subtle%20grain%2C%20high%20detail&width=800&height=500&seq=liao-cover-brief1&orientation=landscape",
    content: [
      "第一条：某组合「明年三月重启巡演」。卡点在于行程信息只出现在一个二手票务群，没有任何场馆或主办方的备案动作。目前不成立。",
      "第二条：某演员「已签下头部电影女主」。卡点在于消息源与片方均无交集，且该片目前尚未完成备案公示。属于早期接触被放大成签约，存疑。",
      "第三条：某歌手「与老东家续约五年」。卡点在于续约通常不需要注销主体，而本周该歌手名下确实有主体变更动作，方向相反。可能性较低。",
      "第四条：某综艺「原班人马全部回归」。卡点在于只有两位常驻确认，其余均无排期信息。属于把部分事实说成全部，不成立。",
      "第五条：某品牌「终止全部艺人合作」。卡点在于该品牌今年本就没有新的艺人签约计划，把它读成终止属于误读。不成立。",
      "这份清单的意义不是否定所有传闻，而是提醒读者：一条信息在缺少可核对的第三方依据时，无论传播得多广，都只能算线索。我们每周会固定整理一期，欢迎在栏目里对照。",
    ],
  },
  {
    id: "daily-brief-0910",
    slug: "daily-brief-0910",
    title: "速递快报：今日十条新料速览（9 月 10 日）",
    categorySlug: "briefs",
    categoryName: "快报专栏",
    author: "料闻社快报组",
    date: "2026-09-10",
    readTime: 3,
    views: 24150,
    hot: false,
    tags: ["快报", "今日速递", "清单"],
    excerpt:
      "十分钟看完今天的动态：从录音棚路透到品牌物料撤换，我们把今日值得记录的十条变化压缩成一份清单，附上可信度标注。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20newspaper%20columns%20abstracted%20into%20warm%20amber%20and%20cream%20paper%20strips%20on%20dark%20background%2C%20rhythmic%20vertical%20pattern%2C%20editorial%20graphic%20design%2C%20soft%20side%20light%2C%20fine%20grain%20texture%2C%20high%20detail&width=800&height=500&seq=liao-cover-brief2&orientation=landscape",
    content: [
      "01｜林知遥连续三晚进入录音棚（可核对，有现场记录）。",
      "02｜沈聿川方回应「目前没有接触」二搭项目（官方口径）。",
      "03｜苏晚棠方称项目「在讨论阶段」（官方口径，与上一条存在差异）。",
      "04｜某顶流工作室主体变更实为业务重组（工商记录可核对）。",
      "05｜顾沉名下一支品牌短片从排期消失（平台记录可核对）。",
      "06｜江砚直播事件的完整原始时长约 118 分钟（原始素材可核对）。",
      "07｜白露旧照在生活方式垂类被集中转发（传播路径可观察）。",
      "08｜本周五条传言缺乏第三方依据（见传言清单）。",
      "09｜两家品牌同步调整合作物料，动作高度一致（时间点可核对）。",
      "10｜某音乐节二轮开票延后三天，主办方未说明原因（公告可核对）。",
      "以上十条里，前五条有可直接核对的记录，后五条属于趋势观察。我们在每条后面标注了依据类型，方便读者自行判断。",
    ],
  },
  {
    id: "short-drama-stars",
    slug: "short-drama-stars",
    title: "短剧造星逻辑：为什么观众开始为三分钟买单",
    categorySlug: "industry",
    categoryName: "行业观察",
    author: "料闻社观察组",
    date: "2026-09-07",
    readTime: 6,
    views: 19380,
    hot: false,
    tags: ["短剧", "行业观察", "内容产业"],
    excerpt:
      "过去一年里，短剧演员的话题量增长速度超过了传统剧集演员。这背后不是运气，而是一套和长视频完全不同的曝光逻辑在起作用。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20vertical%20mobile%20screen%20strips%20glowing%20warm%20amber%20and%20crimson%20against%20dark%20studio%20backdrop%2C%20minimal%20technology%20editorial%20art%2C%20depth%20of%20field%2C%20soft%20haze%2C%20film%20grain%2C%20high%20detail&width=800&height=500&seq=liao-cover-industry1&orientation=landscape",
    content: [
      "长视频捧人靠「作品周期」，一部剧从拍摄到播完通常跨越一年以上；短剧的节奏完全不同，一个演员可能在三个月里上线十几部作品，曝光密度是前者的数倍。",
      "效率是第一层原因。第二层原因更隐蔽：短剧的观众留存依赖强情节，这迫使内容生产端把「记忆点」做得非常锋利。观众记住了情节，也顺带记住了脸。",
      "但这种模式的天花板同样明显。高频曝光带来的是高认知度，而不是高信任度。这解释了为什么短剧演员在商务合作上起步较快，却很难直接进入需要长期形象积累的品牌合作。",
      "最近半年出现一个有意思的转变：部分短剧演员开始主动减少上线频率，转向单部周期更长的项目。这是从「曝光逻辑」切换到「形象逻辑」的信号，能不能成功还要看作品本身。",
      "从产业结构看，短剧不会取代长视频，两者的观众并不完全重叠。更可能的形态是两套体系并行，演员在两者之间流动。对读者来说，理解这套逻辑，比追某一条具体的传闻更有用。",
    ],
  },
  {
    id: "festival-ticket-observation",
    slug: "festival-ticket-observation",
    title: "音乐节票房观察：小众乐队为何一票难求",
    categorySlug: "industry",
    categoryName: "行业观察",
    author: "料闻社观察组",
    date: "2026-09-06",
    readTime: 5,
    views: 16240,
    hot: false,
    tags: ["音乐节", "票房", "现场演出"],
    excerpt:
      "同一场音乐节里，头部乐队的票往往卖得比独立乐队慢。这个反直觉的现象背后，是票务结构和观众结构同时发生了变化。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20outdoor%20festival%20crowd%20silhouettes%20against%20warm%20sunset%20gradient%20of%20amber%20and%20deep%20red%2C%20minimal%20editorial%20poster%20art%2C%20soft%20atmospheric%20haze%2C%20film%20grain%20texture%2C%20high%20detail&width=800&height=500&seq=liao-cover-industry2&orientation=landscape",
    content: [
      "先澄清一个常见误解：音乐节门票并不是按乐队逐个出售的，整体票量由主办方统一分配。所谓「某乐队一票难求」，通常指的是他们的专场或分舞台票。",
      "在这个前提下，独立乐队的专场票之所以更难买，核心原因是供给量小。头部乐队的场次多、场馆大，独立乐队可能一年只演两场，且场地容量有限。稀缺性直接推高了抢票难度。",
      "第二个原因是观众结构。独立乐队的听众重合度更高，同一批人会在多个城市反复购票，这进一步压缩了留给新观众的名额。",
      "第三个原因是传播方式。独立乐队的口碑依赖观众自发分享，这种传播速度慢但转化率高，一旦形成热度，往往是在票已经接近售罄的时候。",
      "所以「一票难求」并不等于商业成绩更好，它更多反映的是供需结构。理解这一点，读者在看到各类票房传闻时就能更冷静地判断真假。",
    ],
  },
  {
    id: "wen-xubai-endorsement",
    slug: "wen-xubai-endorsement",
    title: "温叙白品牌代言更换内情，商务团队回应节奏",
    categorySlug: "events",
    categoryName: "事件追踪",
    author: "料闻社编辑部",
    date: "2026-09-05",
    readTime: 4,
    views: 21960,
    hot: false,
    tags: ["温叙白", "品牌代言", "商务"],
    excerpt:
      "一条代言更换的消息在半天内被解读出三种版本。对照时间点后发现，真正需要关注的是回应速度，而不是更换本身。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20luxury%20product%20pedestal%20with%20soft%20amber%20spotlight%20on%20dark%20burgundy%20background%2C%20minimal%20premium%20brand%20editorial%20aesthetic%2C%20subtle%20smoke%2C%20fine%20grain%20texture%2C%20high%20detail&width=800&height=500&seq=liao-cover-wen&orientation=landscape",
    content: [
      "代言更换在商业合作里属于常规动作，合约到期、品牌策略调整、预算重新分配，任何一种都可能导致更换。这次之所以引发讨论，是因为更换恰好发生在一支新广告上线之后。",
      "从时间点看，新广告上线的时间是 9 月 3 日，更换消息出现在 9 月 4 日晚，商务团队的回应在 9 月 5 日上午。整个链条不到两天，节奏在同类事件里属于偏快。",
      "回应内容本身没有提供太多信息，只说明「合作按合约正常推进」。这种表述通常用于两种情况：合约确实没变动，或者变动细节还不便公开。",
      "比较值得注意的是品牌方的沉默。截至目前，品牌官方渠道没有做任何说明，也没有撤下已经上线的物料。这至少说明双方没有进入对抗状态。",
      "结论：目前没有证据支持「关系破裂」的说法。我们从时间线上观察到的唯一异常是回应稍快，而回应快往往意味着团队提前预判了舆情。这一条我们会继续跟进。",
    ],
  },
  {
    id: "xu-linfeng-variety",
    slug: "xu-linfeng-variety",
    title: "许临风综艺镜头被剪？制片方首次回应",
    categorySlug: "events",
    categoryName: "事件追踪",
    author: "料闻社编辑部",
    date: "2026-09-04",
    readTime: 4,
    views: 18730,
    hot: false,
    tags: ["许临风", "综艺", "剪辑"],
    excerpt:
      "「被剪」的说法来自两期节目的镜头时长对比。我们把三期节目的出场数据拉出来做了对照，结论比传言要平淡得多。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20film%20editing%20timeline%20with%20warm%20amber%20frames%20on%20dark%20editing%20suite%20background%2C%20minimal%20cinema%20editorial%20art%2C%20soft%20screen%20glow%2C%20shallow%20depth%20of%20field%2C%20fine%20grain%2C%20high%20detail&width=800&height=500&seq=liao-cover-xu&orientation=landscape",
    content: [
      "争议的起点是第三期与第二期的镜头时长差异。观众按体感估算许临风的出场时间下降了近一半，于是「被剪」的说法开始传播。",
      "我们按可核对的方式重新统计了三期节目：第二期出场约 14 分钟，第三期约 8 分钟，第四期回到 12 分钟。第三期确实偏低，但第四期并未延续下降趋势，这不太符合「持续被剪」的特征。",
      "更合理的解释与节目结构有关。第三期是嘉宾对抗赛制，镜头天然集中在胜负环节的参与者身上，而许临风所在队伍在前半段就被淘汰。赛制影响远大于剪辑意图。",
      "制片方在回应里给出的说法与此一致，并补充说明每期成片时长为固定值，镜头的分配由赛制结果决定。这是目前唯一来自官方的口径。",
      "所以这条线索的价值不在于「有没有被剪」，而在于提醒大家：综艺镜头时长的波动经常由赛制而非人事原因造成，用单期数据推断态度容易得出错误结论。",
    ],
  },
];

export const figures = [
  {
    name: "林知遥",
    role: "歌手 / 创作人",
    focus: "新专辑进度",
    heat: 96,
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20portrait%20silhouette%20formed%20by%20warm%20vermillion%20and%20amber%20paper%20cut%20shapes%20on%20dark%20charcoal%20background%2C%20editorial%20magazine%20art%2C%20soft%20gradient%20light%2C%20fine%20grain%20texture%2C%20high%20detail&width=400&height=400&seq=liao-fig-lin&orientation=squarish",
  },
  {
    name: "顾沉",
    role: "演员",
    focus: "合约关系变动",
    heat: 93,
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20portrait%20silhouette%20formed%20by%20deep%20maroon%20and%20soft%20cream%20paper%20cut%20shapes%20on%20dark%20background%2C%20editorial%20magazine%20art%2C%20soft%20gradient%20light%2C%20fine%20grain%20texture%2C%20high%20detail&width=400&height=400&seq=liao-fig-gu&orientation=squarish",
  },
  {
    name: "江砚",
    role: "主持人",
    focus: "直播口误事件",
    heat: 88,
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20portrait%20silhouette%20formed%20by%20burnt%20orange%20and%20pale%20gold%20paper%20cut%20shapes%20on%20dark%20ink%20background%2C%20editorial%20magazine%20art%2C%20soft%20gradient%20light%2C%20fine%20grain%20texture%2C%20high%20detail&width=400&height=400&seq=liao-fig-jiang&orientation=squarish",
  },
  {
    name: "苏晚棠",
    role: "演员",
    focus: "合作项目讨论中",
    heat: 85,
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20portrait%20silhouette%20formed%20by%20rose%20red%20and%20warm%20beige%20paper%20cut%20shapes%20on%20dark%20brown%20background%2C%20editorial%20magazine%20art%2C%20soft%20gradient%20light%2C%20fine%20grain%20texture%2C%20high%20detail&width=400&height=400&seq=liao-fig-su&orientation=squarish",
  },
  {
    name: "白露",
    role: "模特 / 演员",
    focus: "旧照翻红",
    heat: 79,
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20portrait%20silhouette%20formed%20by%20sepia%20brown%20and%20pale%20cream%20paper%20cut%20shapes%20on%20dark%20background%2C%20editorial%20magazine%20art%2C%20soft%20gradient%20light%2C%20fine%20grain%20texture%2C%20high%20detail&width=400&height=400&seq=liao-fig-bailu&orientation=squarish",
  },
  {
    name: "温叙白",
    role: "演员",
    focus: "品牌合作调整",
    heat: 74,
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20abstract%20portrait%20silhouette%20formed%20by%20burgundy%20and%20soft%20gold%20paper%20cut%20shapes%20on%20dark%20background%2C%20editorial%20magazine%20art%2C%20soft%20gradient%20light%2C%20fine%20grain%20texture%2C%20high%20detail&width=400&height=400&seq=liao-fig-wen&orientation=squarish",
  },
];

export const eventTimeline = [
  {
    date: "08-30",
    time: "23:40",
    title: "首条传闻出现",
    desc: "一个注册不满一个月的账号发出「合约到期不续」，无配图，措辞非官方口径。",
    level: "低可信",
  },
  {
    date: "09-02",
    time: "10:15",
    title: "首个可核对信号",
    desc: "两个工作室主体之一的商务授权被暂停，原定短片从官方排期消失。",
    level: "可核对",
  },
  {
    date: "09-05",
    time: "全天",
    title: "品牌方同步动作",
    desc: "三家品牌在同一时段调整相关内容，动作高度同步，说明收到同一份通知。",
    level: "可核对",
  },
  {
    date: "09-07",
    time: "18:20",
    title: "经纪公司第一份声明",
    desc: "核心表述为「合作正常推进」，未提及合约期限与后续安排。",
    level: "官方口径",
  },
  {
    date: "09-09",
    time: "21:05",
    title: "当事人第二份声明",
    desc: "用词为「感谢，未来各自努力」，与第一份声明的指向并不完全一致。",
    level: "官方口径",
  },
  {
    date: "09-10",
    time: "12:30",
    title: "物料撤换与事件收束",
    desc: "两家品牌同步撤下合作物料，第三家保留。事件轮廓基本清晰。",
    level: "可核对",
  },
];

export const faqs = [
  {
    q: "料闻社的信息从哪里来，可信吗？",
    a: "我们把信息来源分为三类并在条目里标注：官方口径、可核对的第三方记录、以及暂缺依据的线索。凡属于第三类的，我们会在标题或正文里明确提示「未证实」，不做定论。",
  },
  {
    q: "为什么有些传闻你们只写「存疑」不给结论？",
    a: "因为结论依赖依据。当一条消息只有单一来源、且找不到可核对的第三方记录时，直接下判断反而会误导读者。标注存疑、把卡点写出来，对读者更有用。",
  },
  {
    q: "站内的内容多久更新一次？",
    a: "常规是三档更新：早上八点整理夜间动态，下午两点跟进当日新增，晚上十点发布当日清单。遇到重大事件会临时加更，并在快报专栏里提示。",
  },
  {
    q: "我可以提供线索吗？",
    a: "可以。页面底部的表单支持线索投递，请尽量写清时间、地点与可核对的依据。我们不会公开投稿人的联系方式，也会对来源做交叉验证后再决定是否发布。",
  },
  {
    q: "内容涉及的人名是真实的吗？",
    a: "站内展示的人物与事件均为虚构设定，用于演示资讯站的信息组织方式与时间线梳理方法，不指向任何真实的个人或机构。",
  },
  {
    q: "如果发现我们写错了怎么办？",
    a: "欢迎指出。请在投递表单里选择「内容纠错」并附上可核对的材料，核实后我们会在原文追加更正说明，而不是直接删除原内容。",
  },
];

export const testimonials = [
  {
    name: "看瓜不站队",
    since: "订阅 11 个月",
    text: "最喜欢时间线组，把互相打架的说法按日期排在一起，谁在什么时候改口一目了然，比自己翻记录省太多事。",
  },
  {
    name: "夜班编辑小周",
    since: "订阅 7 个月",
    text: "快报专栏是我每天下班路上必看的，十分钟能扫完当天动态，还带可信度标注，不会被标题带着走。",
  },
  {
    name: "只信记录不信截图",
    since: "订阅 2 年",
    text: "难得看到一个站点愿意把「未证实」三个字写出来。多数地方只挑最刺激的说法发，这里反而会告诉你哪里卡住了。",
  },
  {
    name: "追更选手 Amber",
    since: "订阅 5 个月",
    text: "界面干净，没有乱七八糟的弹窗，也没有那种跳来跳去的广告，看内容的时候很舒服。",
  },
];

export const contentPrinciples = [
  {
    icon: "ri-shield-check-line",
    title: "依据先行",
    desc: "每条资讯标注依据类型，官方口径、可核对记录、待验证线索分开呈现，不混为一谈。",
  },
  {
    icon: "ri-time-line",
    title: "时间优先",
    desc: "先还原顺序再讨论对错，把动作发生的时间点排在观点之前，避免结果倒推原因。",
  },
  {
    icon: "ri-refresh-line",
    title: "更正在明处",
    desc: "发现错误时追加更正说明而非静默删除，让读者看得到修改的过程。",
  },
  {
    icon: "ri-user-heart-line",
    title: "不越边界",
    desc: "只整理公开可查的信息，不涉及私人住址、联系方式与未公开的个人隐私内容。",
  },
];